/**
 * @module utils/columnSort/syncFromQB/syncColumnSortVirtualColumns
 * @description 列占比 / 维度占比虚拟列统一同步（源 metric → dim_pct → %）
 */

import type { IColumnSortItem } from '@/pages/datalab/pages/Multidimensional/Analysis/types/chartSettings/fieldColumnSort';
import type { IColumnPercentageItem } from '../untils/columnPercentage';
import type { IDimensionPercentageConfig } from '../../../../types/settings/dimensionPercentage';
import { dedupeColumnSortList } from '../untils/keys';
import { applyPercentVirtualColumns } from './syncPercentage';
import { applyDimensionPctVirtualColumns } from './syncDimensionPercentage';

/**
 * 按 column_percentage / dimension_percentage 同步虚拟列。
 * 顺序：先 % 再 dim_pct，保证 dim_pct 紧跟源 metric、% 在其后。
 */
export function syncColumnSortVirtualColumns(
  list: IColumnSortItem[],
  columnPercentage: IColumnPercentageItem[] | undefined,
  dimensionPercentage: IDimensionPercentageConfig | undefined,
): IColumnSortItem[] {
  let next = dedupeColumnSortList(list);
  if (columnPercentage?.length) {
    next = applyPercentVirtualColumns(next, columnPercentage);
  }
  if (dimensionPercentage) {
    next = applyDimensionPctVirtualColumns(next, dimensionPercentage);
  }
  return next;
}
